// extracted by mini-css-extract-plugin
export default {"caption":"BlogTags_caption__uehIY","left_line":"BlogTags_left_line__zdLwA"};